<mat-sidenav-container hasBackdrop="false">
  <mat-sidenav-content>
    <ng-content></ng-content>
  </mat-sidenav-content>
  <mat-sidenav
    [fixedInViewport]="true"
    fixedTopGap="40"
    [mode]="'over'"
    #panel
    class="panel"
    position="end"
  >
    <!-- we load different components dynamically -->
    <ng-container #content></ng-container>
  </mat-sidenav>
</mat-sidenav-container>
